<template>
  <div
    :class="{'inline': !isMultipleBadges}"
    class="badge-container">
    <div
      :class="{'negative': isNegativeOffset, 'hide': !startOffsetMs}"
      class="shift-badge --offset">
      <i class="fas fa-backward" v-if="isNegativeOffset"></i>
      <i class="fas fa-forward" v-if="!isNegativeOffset"></i>
      <span class="prefix" v-if="isThaiUI && isNegativeOffset">{{$t('timeShift.slower')}} </span>
      <span class="prefix" v-if="isThaiUI && !isNegativeOffset">{{$t('timeShift.faster')}} </span>
      <span class="numbers">{{startOffsetMinutes}}:{{startOffsetSeconds}} </span>
      <span class="unit">{{$t('common:minute', { count: startOffsetMinutesInt })}} </span>
      <span class="prefix" v-if="isEnglishUI && isNegativeOffset">{{$t('timeShift.slower')}} </span>
      <span class="prefix" v-if="isEnglishUI && !isNegativeOffset">{{$t('timeShift.faster')}} </span>
    </div>
    <div
      :class="{'negative': isNegativeDuration, 'hide': !durationOffsetMs}"
      class="shift-badge --duration">
      <i class="fas fa-chevron-down" v-if="isNegativeDuration"></i>
      <i class="fas fa-chevron-up" v-if="!isNegativeDuration"></i>
      <span class="prefix">{{$t('timeShift.programDuration')}} </span>
      <span class="prefix">{{durationPrefix}}</span>
      <span class="numbers">{{durationMinutes}}:{{durationSeconds}} </span>
      <span class="unit">{{$t('common:minute', { count: durationMinutesInt })}} </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { leadingZero } from '@/utils/time';

export default {
  props: {
    scheduleItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      startOffsetMs: 0,
      durationOffsetMs: 0,
      isMultipleBadges: false,
      isNegativeOffset: false,
      isNegativeDuration: false,
      startOffsetPrefix: '',
      startOffsetMinutes: '',
      startOffsetMinutesInt: 0,
      startOffsetSeconds: '',
      durationPrefix: '',
      durationMinutes: '',
      durationMinutesInt: 0,
      durationSeconds: '',
    };
  },
  computed: {
    ...mapGetters(['userLanguage']),
    isThaiUI() {
      return this.userLanguage === 'th';
    },
    isEnglishUI() {
      return this.userLanguage === 'en';
    },
  },
  created() {
    this.generateBadge();
  },
  methods: {
    generateBadge() {
      this.startOffsetMs = _.get(this.scheduleItem, 'adjustment.startedAtOffsetMs', 0);
      this.durationOffsetMs = _.get(this.scheduleItem, 'adjustment.durationOffsetMs', 0);

      if (this.startOffsetMs !== 0 && this.durationOffsetMs !== 0) {
        this.isMultipleBadges = true;
      }
      if (this.startOffsetMs < 0) {
        this.isNegativeOffset = true;
      }
      if (this.durationOffsetMs < 0) {
        this.isNegativeDuration = true;
      }

      this.createOffsetBadge();
      this.createDurationBadge();
    },
    createOffsetBadge() {
      const startOffsetMinutes = this.getMinutesOnlyFromMs(this.startOffsetMs, true);
      const startOffsetSeconds = this.getSecondsOnlyFromMs(this.startOffsetMs, true);
      this.startOffsetMinutesInt = startOffsetMinutes;

      this.startOffsetMinutes = leadingZero(startOffsetMinutes);
      this.startOffsetSeconds = leadingZero(startOffsetSeconds, false);
      this.startOffsetPrefix = this.isNegativeOffset ? this.$t('timeShift.slower') : this.$t('timeShift.faster');
    },
    createDurationBadge() {
      const durationOffsetMinutes = this.getMinutesOnlyFromMs(this.durationOffsetMs);
      const durationOffsetSeconds = this.getSecondsOnlyFromMs(this.durationOffsetMs);
      this.durationMinutesInt = durationOffsetMinutes;

      this.durationMinutes = leadingZero(durationOffsetMinutes, false);
      this.durationSeconds = leadingZero(durationOffsetSeconds, false);
      this.durationPrefix = this.isNegativeDuration ? '-' : '+';
    },
    getMinutesOnlyFromMs(ms, forcedPositive = false) {
      let result = ms / 60000;
      result = Math.floor(result);
      if (forcedPositive) {
        result = Math.abs(result);
      }
      return result;
    },
    getSecondsOnlyFromMs(ms, forcedPositive = false) {
      let result = ms % 60000;
      result = Math.floor(result / 1000);
      if (forcedPositive) {
        result = Math.abs(result);
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.badge-container {
  margin-left: -4px;
  &.inline {
    display: inline-block;
    margin-left: 2px;
  }
}

.shift-badge {
  display: inline-block;
  color: $dark-900;
  background: $dark-300;
  padding: 2px 5px;
  border-radius: 4px;
  margin-left: 2px;
  font-size: 13px;
  .fas {
    margin-right: 4px;
  }
  .unit {
    text-transform: lowercase;
  }
  &.--duration {
    color: #FFF;
    background: $dark-lavender;
  }
  &.hide {
    display: none;
  }
}
</style>
